import type { QueueItem } from "./queue"

// Triage buckets for the batch review table. This lives apart from queue.ts
// because queue.ts pulls in scripts/review-ledger (fs/crypto/path) and so is
// server-only; bucketOf must be importable from the client batch table, so it
// depends on nothing but the QueueItem *type* (erased at runtime).
export type Bucket = "safe" | "trap" | "differs"

const isEnglishVariant = (locale: string) =>
  locale.toLowerCase().startsWith("en")

/** Triage bucket for a queue item (see the triage section of the spec). Reads `locale`
 *  so identical-to-EN counts as "safe" only for English variants (en-NL); for a
 *  German/Dutch file an identical entry is untranslated → a trap. */
export function bucketOf(
  item: Pick<QueueItem, "identicalToEn" | "marketTokens" | "locale">
): Bucket {
  if (item.marketTokens.length > 0) return "trap"
  if (item.identicalToEn) return isEnglishVariant(item.locale) ? "safe" : "trap"
  return "differs"
}
